import { lazy } from '@cobliteam/lazy-with-retries';
import { Suspense } from 'react';

// AppAnnouncement is portalled to document.body from every private route, but its content
// only renders when the Prismic announcement endpoint returns an active card. The card
// itself pulls Typeform (~58 KB), Prismic rich text, and InfoCard variants — none of which
// need to load until an announcement exists. Lazy the whole card.
const AppAnnouncementCard = lazy(() => import('./components/AppAnnouncementCard'));

const AppAnnouncement = () => {
  return (
    <Suspense fallback={null}>
      <AppAnnouncementCard />
    </Suspense>
  );
};

export default AppAnnouncement;
